/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CommunityCardFragmentFragment } from "@cosmos/hygraph-schema";
import { ReactNode } from "react";

import { CosmosCard, CosmosText, CosmosTextVariantEnum, EdsIcon, EdsIconType } from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

const cardStyles = css({
	"&&": {
		display: "flex",
		flexDirection: "column",
		p: "eds.dimension.20",
		alignItems: "center",
		textAlign: "center",
	},
});

const linkStyles = css({
	"&&": {
		position: "absolute",
		inset: "0",
	},
});

const descStyles = css({
	overflowWrap: "anywhere",
	textOverflow: "ellipsis",
	lineClamp: "2",
	overflow: "hidden",
});

export const CommunityCard = ({
	iconType,
	iconGradient,
	title,
	description,
	link,
	className,
}: CommunityCardFragmentFragment & { className?: string }): ReactNode => {
	return (
		<CosmosCard className={cx("community-card", className, cardStyles)} borderRadius={24} variant="material">
			{link && link.href && link.label && (
				<CosmosCard.Link href={link.href} title={link.label} className={linkStyles} />
			)}
			{iconType && <EdsIcon icon={iconType as EdsIconType} size="xl" gradient={iconGradient} />}
			<VStack gap="eds.dimension.8">
				<CosmosText as="h3" variant={CosmosTextVariantEnum.headingSM}>
					{title}
				</CosmosText>
				<CosmosText variant={CosmosTextVariantEnum.paragraphSM} color="eds.text.secondary" className={descStyles}>
					{description}
				</CosmosText>
			</VStack>
		</CosmosCard>
	);
};
